import { AButton, AModal, ATitle, StatusFinancial } from '../../../components';
import {
  ContainerDescriptionList,
  ContainerRowModalTitle,
  DescriptionText,
  RowDescription,
} from '../styles';
import { ContainerFinancialToPayList } from './styles';
import { IFinancial } from '../../../shared/interfaces';
import { List } from 'antd';
import { formatDate } from '../../../shared/utils/format-date';
import { currency } from '../../../shared/utils/functions';
import { DollarCircleFilled } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

interface IFinancialToPayProps {
  open: boolean;
  close: () => void;
  financials: IFinancial[];
  toPay: number;
}

const FinancialToPay: React.FC<IFinancialToPayProps> = ({
  open,
  close,
  financials,
  toPay,
}) => {
  const navigate = useNavigate();

  return (
    <AModal
      open={open}
      close={close}
      width={800}
      title={
        <ContainerRowModalTitle>
          <ATitle>Contas à pagar que venceram até o momento!</ATitle>
          <ATitle color="#f34553">{currency(toPay)}</ATitle>
        </ContainerRowModalTitle>
      }
      footer={
        <>
          <AButton onClick={close}>Fechar</AButton>
        </>
      }
    >
      <ContainerFinancialToPayList>
        <List
          itemLayout="horizontal"
          dataSource={financials}
          renderItem={(item) => (
            <List.Item
              actions={[
                <a
                  key="list-loadmore-edit"
                  onClick={() => navigate(`/financial/${item.id}`)}
                >
                  Editar
                </a>,
              ]}
            >
              <List.Item.Meta
                avatar={
                  <DollarCircleFilled
                    style={{ fontSize: 40, color: '#cf1322' }}
                  />
                }
                title={
                  <DescriptionText bold style={{ color: '#f34553' }}>
                    {item.client_name}
                  </DescriptionText>
                }
                description={
                  <ContainerDescriptionList>
                    <RowDescription>
                      <DescriptionText bold>Código:</DescriptionText>
                      <DescriptionText>{item.code}</DescriptionText>
                    </RowDescription>
                    <RowDescription>
                      <DescriptionText bold>Valor:</DescriptionText>
                      <DescriptionText>{currency(item.value)}</DescriptionText>
                    </RowDescription>
                    <RowDescription>
                      <DescriptionText bold>Data Vencimento:</DescriptionText>
                      <DescriptionText>
                        {formatDate(item.due_date)}
                      </DescriptionText>
                    </RowDescription>
                    <RowDescription>
                      <DescriptionText bold> Situação:</DescriptionText>
                      <DescriptionText>
                        <StatusFinancial status={item.status} />
                      </DescriptionText>
                    </RowDescription>
                    <RowDescription>
                      <DescriptionText bold> Nº Doc:</DescriptionText>
                      <DescriptionText>{item.number_doc}</DescriptionText>
                    </RowDescription>
                    <RowDescription>
                      <DescriptionText bold>Observação:</DescriptionText>
                      <DescriptionText>
                        {item.observation ?? 'Sem informação'}
                      </DescriptionText>
                    </RowDescription>
                  </ContainerDescriptionList>
                }
              />
            </List.Item>
          )}
        />
      </ContainerFinancialToPayList>
    </AModal>
  );
};

export default FinancialToPay;
